import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getDocumentContractfarming } from "../../../../auth/services/privateapicalling";
 
const DocView: React.FC = () => {
  const [docId, setDocId] = useState<string | null>(null);
  const [file, setFile] = useState<{ fileData: string; mimeType: string; fileName: string } | null>(null);
  const [loading, setLoading] = useState(false);
  const token = useSelector((state: any) => state.auth.token);
  const language = useSelector((state:any)=>state.auth.language);

  useEffect(() => {
    const modalElement = document.getElementById('contract_farming_modal');
    
    const handleModalShow = (event: any) => {
      const button = event.relatedTarget; // Button that triggered the modal
      const docIdFromButton = button?.getAttribute('data-doc-id');
      setDocId(docIdFromButton);
    };

    modalElement?.addEventListener('show.bs.modal', handleModalShow);

    return () => {
      modalElement?.removeEventListener('show.bs.modal', handleModalShow);
    };
  }, []);

  useEffect(() => {
    const loadFile = async () => {
      if (!docId) return;
      setFile(null);
      setLoading(true);
      try {
        const response = await getDocumentContractfarming(docId, token);
      

        if (response.success && response.attachments) {
          const [key] = Object.keys(response.attachments);
          const attachment = response.attachments[key];

          setFile({
            fileData: attachment.base64,
            mimeType: attachment.contentType,
            fileName: key,
          });
        } else {
          setFile(null);
        }
      } catch (error) {
      
        setFile(null);
      }
      setLoading(false);
    };

    loadFile();
  }, [docId, token]);

 
 
  return (
    <div className="modal fade" id="contract_farming_modal" tabIndex={-1} aria-hidden="true">
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{language.vdoc}</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body" style={{ maxHeight: "500px", overflowY: "auto" }}>
            {loading && <p>Loading...</p>}
            {!loading && !file && <p>No document found</p>}
            {file && (
              <div className="mt-3">
                <p>
                  <strong>
                    {file.fileName.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                  </strong>
                </p>
                {file.mimeType.startsWith("image/") && (
                  <img src={file.fileData} alt={file.fileName} style={{ width: "100%", maxHeight: "700px" }} />
                )}
                {file.mimeType === "application/pdf" && (
                  <iframe src={file.fileData} width="100%" height="500px" title="PDF Viewer" />
                )}
                {!file.mimeType.startsWith("image/") && file.mimeType !== "application/pdf" && (
                  <a href={file.fileData} download={file.fileName} className="text-primary">
                    {language.down} {file.fileName}
                  </a>
                )}
              </div>
            )}
          </div>
          <div className="modal-footer d-flex justify-content-between">
            {file && (
              <a href={file.fileData} download={file.fileName} className="btn btn-success">
                {language.down}
              </a>
            )}
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
              {language.close}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DocView;